import { initErrorMonitor } from '../configs/errorMonitor';

import { installResourceLoadGuard } from './resourceLoadGuard';
import { installSilentOpaqueScriptErrorGuard } from './silentOpaqueScriptError';
import { installSilentResourceErrorGuard } from './silentResourceError';
import { uuidV1 } from './uuid';

export const setupErrorMonitor = () => {
    try {
        // 先于 error-base / 业务监听：静默第三方与 .map 资源错误
        installSilentResourceErrorGuard();
        // 跨域 opaque Script error.：须在 error-base 之前 capture 拦截
        installSilentOpaqueScriptErrorGuard();
        // 资源加载自愈 / 静默：须在其他 error 监听之前以 capture 注册
        installResourceLoadGuard();

        // 这里可以从用户登录信息中获取用户ID
        const userId = window.adv ? window.adv.getAdvUUID() : uuidV1();

        initErrorMonitor(userId);

        // 监听全局未捕获的错误
        window.addEventListener('error', (event) => {
            console.error('Uncaught error:', event.error);
        });

        // 监听Promise中未捕获的错误
        window.addEventListener('unhandledrejection', (event) => {
            console.error('Unhandled promise rejection:', event.reason);
        });
    } catch (e) {
        console.error('Error initializing error monitor:', e);
    }
};
